export enum DataType {
  Container = 'containers',
  ContainerType = 'container-types',
  IncidentType = 'incident-types',
  Room = 'rooms',
}
